import { render, staticRenderFns } from "./UptimecumulativeReport.vue?vue&type=template&id=28f9b712&"
import script from "./UptimecumulativeReport.vue?vue&type=script&lang=js&"
export * from "./UptimecumulativeReport.vue?vue&type=script&lang=js&"
import style0 from "./UptimecumulativeReport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports